export const contactListData = [
  {
    key:"1",
    Image: "user-49.jpg",
    Name: "Darlee Robertson",
    Roll: "Facility Manager",
    Email: "darlee@example.com",
    Phone: "(163) 2459 315",
    Location: "Germany",
    Rating: "4.2",
    Owner: "Hendry Milner",
    Status: "Active",
  },
  {
    key:"2",
    Image: "user-50.jpg",
    Name: "Sharon Roy",
    Roll: "Installer",
    Email: "sharon@example.com",
    Phone: "(146) 1249 296",
    Location: "USA",
    Rating: "5",
    Owner: "Guilory Berggren",
    Status: "Active",
  },
  {
    key:"3",
    Image: "user-51.jpg",
    Name: "Vaughan Lewis",
    Roll: "Senior  Manager",
    Email: "vaughan@example.com",
    Phone: "(135) 3489 516",
    Location: "Canada",
    Rating: "3.5",
    Owner: "Jami Carlile",
    Status: "Active",
  },
  {
    key:"4",
    Image: "user-02.jpg",
    Name: "Jessica Louise",
    Roll: "Test Engineer",
    Email: "jessica@example.com",
    Phone: "(158) 3459 596",
    Location: "India",
    Rating: "4.5",
    Owner: "Theresa Nelson",
    Status: "Active",
  },
  {
    key:"5",
    Image: "user-52.jpg",
    Name: "Carol Thomas",
    Roll: "UI /UX Designer",
    Email: "carol@example.com",
    Phone: "(196) 4862 196",
    Location: "China",
    Rating: "4.7",
    Owner: "Smith Cooper",
    Status: "Active",
  },
  {
    key:"6",
    Image: "user-57.jpg",
    Name: "Dawn Mercha",
    Roll: "Technician",
    Email: "dawn@example.com",
    Phone: "(163) 6498 256",
    Location: "Japan",
    Rating: "5",
    Owner: "Martin Lewis",
    Status: "Active",
  },
  {
    key:"7",
    Image: "user-54.jpg",
    Name: "Rachel Hampton",
    Roll: "Software Developer",
    Email: "rachel@example.com",
    Phone: "(154) 6481 075",
    Location: "Indonesia",
    Rating: "3.1",
    Owner: "Newell Egan",
    Status: "Active",
  },
  {
    key:"8",
    Image: "user-56.jpg",
    Name: "Jonelle Curtiss",
    Roll: "Supervisor",
    Email: "jonella@example.com",
    Phone: "(184) 6348 195",
    Location: "Cuba",
    Rating: "5",
    Owner: "Janet Carlson",
    Status: "Active",
  },
  {
    key:"9",
    Image: "user-26.jpg",
    Name: "Jonathan Smith",
    Roll: "Team Lead Dev",
    Email: "jonathan@example.com",
    Phone: "(175) 2496 125",
    Location: "Israel",
    Rating: "2.7",
    Owner: "Craig Brown",
    Status: "Active",
  },
  {
    key:"10",
    Image: "user-36.jpg",
    Name: "Patricia Carter",
    Roll: "Team Lead Dev",
    Email: "patricia@example.com",
    Phone: "(132) 3145 977",
    Location: "Colombia",
    Rating: "3",
    Owner: "Daniel Byrne",
    Status: "Active",
  },
  {
    key:"10",
    Image: "user-20.jpg",
    Name: "Jeffrey Jarrett",
    Roll: "Team Lead Dev",
    Email: "jeffrey@example.com",
    Phone: "(167) 4526 5496",
    Location: "Iran",
    Rating: "4.6",
    Owner: "Daniel Byrne",
    Status: "Active",
  },
  {
    key:"10",
    Image: "user-24.jpg",
    Name: "Gloria Rubio",
    Roll: "Team Lead Dev",
    Email: "gloria@example.com",
    Phone: "(134) 7589 6348",
    Location: "Brazil",
    Rating: "4.1",
    Owner: "Craig Brown",
    Status: "Active",
  },
];
